import { inject } from "@angular/core";
import type { ResolveFn } from "@angular/router";

import { OrderView } from "../shared/models";
import { WarehouseStore } from "./warehouse.store";

/**
 * Router resolver to ensure that warehouse orders to prepare are loaded
 * before activating a route.
 *
 * @returns {boolean} Always `true` to allow the route to activate immediately.
 */
export const warehouseResolver: ResolveFn<boolean> = (): boolean => {
  const store = inject(WarehouseStore);

  if (!store.views().TO_PREPARE.isLoaded) {
    store.loadOrders(OrderView.TO_PREPARE);
  }

  if (!store.views().TO_SHIP.isLoaded) {
    store.loadOrders(OrderView.TO_SHIP);
  }

  return true;
};
